import Box from "@/components/Box";

export default function Spacer({ py, ...rest }) {
  return <Box py={py} {...rest} />;
}
